export const lpad = (s, c, n) => {
  if (typeof s === 'number') {
    s = s.toString();
  } else if (! s || ! c || s.length >= n) {
      return s;
  }
  const max = (n - s.length)/c.length;
  for (let i = 0; i < max; i++) {
      s = c + s;
  }
  return s;
}

export const getHolidayText = (holiday) => {
  switch(holiday) {
    case 'nodata': return 'NoData'
    case 'half': return '반차'
    case 'workhome': return '재택'
    default: return '연차'
  }
}



// WEBPACK FOOTER //
// ./src/utils/string.js